import { useState, useEffect } from 'react';
import { useSiteConfig } from '@bingads-webui-campaign-react/smart-page-context';
import { loadLocalImage } from '@bingads-webui-campaign-react/static-local-image-selector';

export const useLocalImage = (imageName) => {
  const [localImageSrc, setLocalImageSrc] = useState(null);
  const { dispatchSiteConfig } = useSiteConfig();

  useEffect(() => {
    if (imageName) {
      loadLocalImage(imageName)
        .then((src) => {
          setLocalImageSrc(src);
          dispatchSiteConfig({
            type: 'UPDATE_LOCAL_IMAGE_URL',
            payload: src,
          });
        });
    }
  }, [imageName, dispatchSiteConfig]);

  return localImageSrc;
};
